export default "__VITE_ASSET__DnaCGVF5__"